import React, { createContext, useEffect, useState } from "react";
import { Routes, Route, Navigate, NavLink } from "react-router-dom";
import { Sidebar, SidebarItem } from "../../components/Sidebar";
import { AiFillHome } from "react-icons/ai";
import { BiLogInCircle } from "react-icons/bi";

import ApiKey from "./components/ApiKey/ApiKey";
import { useApolloClient, useQuery } from "@apollo/client";
import { CiReceipt } from "react-icons/ci";
import { FaCode } from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import Overview from "./Overview/Overview";
import { FaWpforms } from "react-icons/fa6";
import { MdAccountBalanceWallet } from "react-icons/md";
import Profile from "./Profile/Profile";
import TeamMember from "./TeamMember/TeamMembers";
import ChangePassword from "./ChangePassword/ChangePassword";
import {
  GET_SETTLEMENT_REPORTS,
  GET_TRANSACTION_REPORT,
} from "../../Qurries";
import Payments from "./Payments/Payments";
import TransactionReceipt from "./Transaction/TransactionReceipt";
import Vendor from "./Vendor/Vendor";
import { getStartAndEndOfMonth } from "../../utils/getStartDateAndEndDate";
import VendorTransactionReceipt from "./Payments/VendorTransactionReceipt";
import PosDevice from "./PosDevice/PosDevice";
import pos from "../../assets/edc.png";
import TransactionsOfSettlement from "./Settlement/TransactionsOfSettlement";
import { CgCopy } from "react-icons/cg";
import Reports from "./Reports/Reports";
import GetFormSidebar from "./GetForm/GetFormSidebar/GetFormSidebar";
import VendorTransactionofSettlement from "../Dashboard/Payments/VendorTransactionofSettlement";
import Payouts from "./Payouts/Payouts";
import {
  canAccessPayoutsSchool,
  getMerchantSchoolId,
} from "../../utils/payoutAccess";
import { shouldSkipMerchantGraphql } from "../../utils/payoutLocalShell";
import {
  clearPayoutsAuthCache,
  probePayoutsEnrollment,
  setPayoutsMerchantSchoolId,
} from "./Payouts/api/payoutApiClient";
export enum Access {
  ADMIN = "admin",
  MANAGEMENT = "management",
  OWNER = "owner",
  FINANCE_TEAM = "finance_team",
  DEVELOPER = "developer",
}

type PayoutAccessProbe = "pending" | "allowed" | "denied";

function PayoutsRouteGate({
  menu,
  probe,
}: {
  menu: boolean;
  probe: PayoutAccessProbe;
}) {
  if (probe === "pending") {
    return (
      <div className="flex min-h-[40vh] w-full items-center justify-center px-8 py-16 text-sm font-semibold text-[#505E8E]">
        Loading payouts access…
      </div>
    );
  }
  if (probe === "allowed") {
    return <Payouts menu={menu} />;
  }
  return <Navigate to="/" replace />;
}

export const dashboardContext = createContext<any>(null);
function Dashboard({ user, set_user }: any) {
  const [menu, setMenu] = useState(false);
  const [transaction, setTransaction] = useState<any>(null);
  const [payoutAccessProbe, setPayoutAccessProbe] = useState<PayoutAccessProbe>("pending");
  const payoutAccessAllowed = payoutAccessProbe === "allowed";
  const skipMerchantGraphql = shouldSkipMerchantGraphql();
  const { data: settlementData } = useQuery(GET_SETTLEMENT_REPORTS, {
    skip: skipMerchantGraphql,
    errorPolicy: "ignore",
  });
  const { startDate, endDate } = getStartAndEndOfMonth();
  const { data: transactionReport } =
    useQuery(GET_TRANSACTION_REPORT, {
      skip: skipMerchantGraphql,
      errorPolicy: "ignore",
      variables: {
        startDate: startDate,
        endDate: endDate,
      },
    });

  const client = useApolloClient();

  useEffect(() => {
    let cancelled = false;
    const schoolId = getMerchantSchoolId(user);
    if (schoolId) setPayoutsMerchantSchoolId(schoolId);

    const schoolEnabled = canAccessPayoutsSchool(user);
    if (!schoolEnabled) {
      setPayoutAccessProbe("denied");
      clearPayoutsAuthCache();
      return;
    }

    setPayoutAccessProbe("pending");
    (async () => {
      const enrolled = await probePayoutsEnrollment(schoolId);
      if (!cancelled) setPayoutAccessProbe(enrolled ? "allowed" : "denied");
    })();

    return () => {
      cancelled = true;
    };
  }, [user]);

  const [tokenData, setTokenData] = useState<{ dashboard?: string; email?: string; role?: string; name: string } | null>(null);

  useEffect(() => {
    try {
      const token = localStorage.getItem("merchantToken");
      if (token) {
        const payload = token.split(".")[1];
        if (payload) {
          const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
          const json = JSON.parse(
            window.atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "="))
          );
          if (json && (json.dashboard !== undefined && json.dashboard !== null && json.dashboard !== "")) {
            setTokenData({
              dashboard: json.dashboard,
              email: json.email,
              role: json.role,
              name: json.name
            });
          }
        }
      }
    } catch (e) {
      console.error("Error decoding merchantToken:", e);
    }
  }, [user]);

  const isRedirectedUser = !!(tokenData && tokenData.dashboard);

  const handleLogout = () => {
    localStorage.removeItem("merchantToken");
    clearPayoutsAuthCache();
    localStorage.removeItem("payoutsMerchantSchoolId");
    localStorage.removeItem("payoutsLocalShell");
    set_user(null);
    client.cache.evict({ fieldName: "getSchoolQuery" });
    client.cache.gc();
    client.cache.reset();
  };

  if (!user) return <Navigate to="/login"></Navigate>;

  return (
    <dashboardContext.Provider
      // schoolsData={schoolsData}
      value={{
        user,
        set_user,
        settlementData,
        transactionReport,
        transaction,
        setTransaction,
        isRedirectedUser,
        tokenData,
      }}
    >
      <div className="dashboard flex w-full">
        <div className="h-full ">
          <Sidebar
            schoolName={"Edviron"}
            Link={NavLink}
            menu={menu}
            setMenu={setMenu}
          >
            <SidebarItem
              icon={<AiFillHome className={"text-lg"} />}
              name="Home"
              to="/"
            />
            <SidebarItem
              icon={<CiReceipt className={"text-lg"} />}
              name="Payments"
              to="/payments/transactions"
            />
            <SidebarItem
              icon={<AiFillHome className={"text-lg"} />}
              name="Vendor"
              to="/vendor"
            />
            <SidebarItem
              icon={<img src={pos} className="w-6 h-6 mb-1" alt="POS Icon" />}
              name="POS"
              to="/pos"
            />
            <SidebarItem
              icon={<FaCode className={"text-lg"} />}
              name="Developer"
              to="/developer"
            />
            <SidebarItem
              icon={<CgCopy className={"text-lg"} />}
              name="Reports"
              to="/reports"
            />
            {payoutAccessAllowed && (
              <SidebarItem
                icon={<MdAccountBalanceWallet className={"text-lg"} />}
                name="Payouts"
                to="/payouts/dashboard"
              />
            )}

            {(isRedirectedUser ? tokenData?.role : user?.getUserQuery?.role) !== Access.FINANCE_TEAM ? (
              <SidebarItem
                icon={<FaWpforms className={"text-lg"} />}
                name="Collection Tools"
                to="/collection-tools"
              />
            ) : (
              <></>
            )}

            <SidebarItem
              className="mt-auto"
              icon={<BiLogInCircle className={"text-lg"} />}
              name="Log Out"
              onTap={handleLogout}
            />
          </Sidebar>
        </div>

        <div
          className={
            "flex flex-col overflow-hidden flex-1 relative  w-full bg-[#EDF1F4] pl-[5rem]"
          }
        >
          <Navbar logOut={handleLogout} />

          <div className="flex flex-col transition-transform pt-[3rem] min-h-screen duration-200">
            <div className="flex overflow-hidden flex-col w-full  z-10 lg:pr-8 pr-4">
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route
                  path="/developer"
                  element={
                    <div className="w-full mr-6 pl-6">
                      <ApiKey />
                    </div>
                  }
                />
                <Route
                  path="/payments/transaction-receipt/:collectId"
                  element={<TransactionReceipt />}
                />
                <Route
                  path="/payments/vendor-transaction-receipt"
                  element={<VendorTransactionReceipt />}
                />
                <Route
                  path="/payments/settlements-transaction"
                  element={<TransactionsOfSettlement />}
                />
                <Route
                  path="/payments/vendor-settlements-transaction"
                  element={<VendorTransactionofSettlement />}
                />
                <Route
                  path="/payments/*"
                  element={<Payments menu={menu} />}
                />
                <Route
                  path="/payments"
                  element={<Navigate to="/payments/transactions" replace />}
                />
                <Route path="/vendor/*" element={<Vendor menu={menu} />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/team-members" element={<TeamMember />} />
                <Route path="/pos" element={<PosDevice />} />
                <Route path="/reports" element={<Reports />} />
                <Route
                  path="/payouts/*"
                  element={<PayoutsRouteGate menu={menu} probe={payoutAccessProbe} />}
                />
                <Route
                  path="/collection-tools/*"
                  element={<GetFormSidebar menu={menu} />}
                />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </dashboardContext.Provider>
  );
}

export default Dashboard;
